module.exports = __webpack_public_path__ + "static/media/product.9614959b.png";